import dayjs from "dayjs";
import { FilterBase } from "../filterBase";
import { DATA_TYPES } from "../filterConstants";

export class DateFilter extends FilterBase {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(filterName, filterType, DATA_TYPES.DATE, dataScopes, information, visibility, restrictedToScope);
  }

  formatCompareData(a, b) {
    return [(new Date(a)).getTime(), (new Date(b)).getTime()];
  }

  additionalFilters(data) { 
    if (!this.to) {
      this.to = dayjs(new Date()).toDate().toDateString();
    }
    if (!this.from) {
      this.from = dayjs(new Date()).toDate().toDateString();
    }
    return data.filter((row) => row[this.filterType] && (new Date(row[this.filterType])) >= (new Date(this.from)) && (new Date(row[this.filterType])) <= (new Date(this.to)))
  }
}